import { Box, Container, Paper, ScrollArea, Stack, Text } from '@mantine/core';
import { createFileRoute } from '@tanstack/react-router';
import * as styles from './$artifactId.css';

export const Route = createFileRoute('/_protected/artifact/$artifactId')({
  component: ArtifactPage,
});

function ArtifactPage() {
  const { artifactId } = Route.useParams();

  return (
    <Stack className={styles.pageContainer}>
      {/* Header */}
      <Box p="md" className={styles.header}>
        <Text size="lg" fw={600}>
          Artifact Viewer
        </Text>
        <Text size="sm" c="dimmed" mt="xs">
          ID: {artifactId}
        </Text>
      </Box>

      {/* Content */}
      <Box className={styles.contentArea}>
        <ScrollArea h="100%" p="md">
          <Container size="md">
            <Paper p="xl" withBorder>
              <Stack gap="md">
                <Text size="sm" c="dimmed">
                  Artifact content will be displayed here based on format (CSV, JSON, PNG, etc.)
                </Text>
                <Text size="sm" c="dimmed">
                  This is a placeholder. Full artifact rendering will be implemented when we add
                  proper artifact fetching and rendering logic.
                </Text>
              </Stack>
            </Paper>
          </Container>
        </ScrollArea>
      </Box>
    </Stack>
  );
}
